module.exports = __webpack_public_path__ + "media/images/site/CINFANTIL_MUSICA_BRINQ_2-e80eba78297b22cb43f7e7f2e8211306.jpg";